<template>
  <v-list class="alerts-list-container">
    <div v-for="(alertMessage, index) in props.alerts" :key="index">
      <AlertsMessagesListItemComponent :alert="alertMessage" />
      <hr class="divider-line" />
    </div>
  </v-list>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { AlertMessage } from '@/store/modules/alertsMessages/alertsMessagesTypes'
import AlertsMessagesListItemComponent from '@/components/AlertsMessages/AlertsMessagesListItemComponent.vue'

// PROPS
const props = defineProps({
  alerts: {
    type: Array as PropType<AlertMessage[]>,
    required: true
  }
})
</script>

<style scoped lang="scss">
.alerts-list-container {
  @include list;
  margin-top: 8px;
  min-height: 300px;

  .divider-line {
    border-top: 1px solid $neutral-grey-300;
    margin: 4px 0;
  }
}
</style>
